import React from 'react';

// eslint-disable-next-line react/prop-types
const CircularClose = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <circle cx="24" cy="24" r="24" fill="#CB2C2C" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6628 17.3462C19.0152 16.8426 18.0787 16.8884 17.4836 17.4836C16.8388 18.1283 16.8388 19.1736 17.4836 19.8183L21.6652 24L17.4836 28.1817L17.3462 28.3372C16.8426 28.9848 16.8884 29.9213 17.4836 30.5165C18.1283 31.1612 19.1736 31.1612 19.8183 30.5165L24 26.3348L28.1817 30.5165L28.3372 30.6538C28.9848 31.1574 29.9213 31.1116 30.5165 30.5165C31.1612 29.8717 31.1612 28.8264 30.5165 28.1817L26.3348 24L30.5165 19.8183L30.6538 19.6628C31.1574 19.0152 31.1116 18.0787 30.5165 17.4836C29.8717 16.8388 28.8264 16.8388 28.1817 17.4836L24 21.6652L19.8183 17.4836L19.6628 17.3462Z"
      fill="white"
    />
  </svg>
);

export default CircularClose;
